import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import { commonActions } from 'srcReact/components'
import Spinner from 'srcReact/components/common2/Spinner'
import InterestPicker from 'srcReact/components/common2/InterestPicker'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { createUpdateGroupActions } from 'srcReact/GroupPage'

const GroupInterests = ({
  show,
  hideNextButton,
  nextSectionVisible,
  containerCss,
  verticalLineCss,
  infoCss,
  innerContainerCss,
  titleCss,
  editMode = false
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [interestsUpdated, setInterestsUpdated] = useState(false)

  const containerRef = useRef(null)

  useEffect(() => {
    if (!editMode) {
      containerRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [show])

  const {
    createUpdateGroup: { editSuccess, loading, groupInfo, groupType },
    common: { selectedInterests }
  } = useSelector((state) => state)
  const [initialSelectedInterests, setInitialSelectedInterests] = useState([])
  const [infoForEditReceived, setInfoForEditReceived] = useState(false)

  useEffect(() => {
    if (!editMode) {
      setInitialSelectedInterests([])
      dispatch(commonActions.updateSelectedInterests([]))
    }
  }, [])

  useEffect(() => {
    if (!editMode) {
      setInitialSelectedInterests([])
      dispatch(commonActions.updateSelectedInterests([]))
    }
  }, [groupType])

  useEffect(() => {
    if (editMode && groupInfo) {
      if (!infoForEditReceived) {
        setInfoForEditReceived(true)
      }
      setInitialSelectedInterests(groupInfo.interests || groupInfo.expertises)
      dispatch(commonActions.updateSelectedInterests(groupInfo.interests || groupInfo.expertises))
    }
  }, [editMode, groupInfo])

  useEffect(() => {
    if (editMode && editSuccess && interestsUpdated) {
      setInterestsUpdated(false)
    }
  }, [editSuccess])

  const handleNext = () => {
    if (
      selectedInterests &&
      selectedInterests.length >= appConstantSettings.MIN_INTEREST_COUNT &&
      selectedInterests.length <= appConstantSettings.MAX_INTEREST_COUNT
    ) {
      dispatch(createUpdateGroupActions.showLocation())
    }
  }

  const onInterestChange = () => {
    setInterestsUpdated(true)
  }

  const handleSave = () => {
    if (
      selectedInterests &&
      selectedInterests.length >= appConstantSettings.MIN_INTEREST_COUNT &&
      selectedInterests.length <= appConstantSettings.MAX_INTEREST_COUNT
    ) {
      const selectedInterstsIds = selectedInterests ? selectedInterests.map((i) => i.id).join(',') : ''
      dispatch(createUpdateGroupActions.editGroup(groupInfo.id, { interest_ids: selectedInterstsIds }))
    }
  }

  const handleCancel = () => {
    setInterestsUpdated(false)
    dispatch(commonActions.updateSelectedInterests(initialSelectedInterests))
  }

  const jumpToNextAfterUpdate = () => {
    if (
      selectedInterests &&
      selectedInterests.length >= appConstantSettings.MIN_INTEREST_COUNT &&
      selectedInterests.length <= appConstantSettings.MAX_INTEREST_COUNT
    ) {
      const nextContainer = document.querySelector('#locationContainer')
      nextContainer.scrollIntoView(true, { behavior: 'smooth' })
    }
  }

  return (
    <React.Fragment>
      <div
        id='interestContainer'
        ref={containerRef}
        className={`${containerCss} ${!nextSectionVisible && !editMode && styles.container} ${
          show ? styles.show : styles.hide
        }`}>
        <div class={verticalLineCss} />
        {!editMode && (
          <React.Fragment>
            <p className={infoCss}>
              {t('group.createGroup.interest.title1', {
                type:
                  groupType === 'expertise'
                    ? t('formlabel.expertise', { count: 0 }).toLowerCase()
                    : t('formlabel.interest', { count: 0 }).toLocaleLowerCase()
              })}
            </p>
          </React.Fragment>
        )}

        <div className={innerContainerCss}>
          <h2 className={titleCss}>
            {editMode
              ? t('group.editGroup.groupInterests', {
                  type:
                    groupType === 'expertise'
                      ? t('formlabel.expertise', { count: 0 }).toLowerCase()
                      : t('formlabel.interest', { count: 0 }).toLocaleLowerCase()
                })
              : t('group.createGroup.interest.title2', {
                  type:
                    groupType === 'expertise'
                      ? t('formlabel.expertise', { count: 0 }).toLowerCase()
                      : t('formlabel.interest', { count: 0 }).toLocaleLowerCase()
                })}
          </h2>
          <InterestPicker
            componentType={groupType}
            origin={editMode ? 'group_edit' : 'group_creation'}
            entityId={editMode ? groupInfo?.id : 0}
            containerCss={styles.interestPickerContainer}
            onInterestChange={onInterestChange}
            primaryButton={
              editMode
                ? interestsUpdated
                  ? {
                      text: loading ? <Spinner isWhite={true} /> : t('global.save'),
                      size: 'large',
                      clickHandler: handleSave
                    }
                  : null
                : !hideNextButton
                ? {
                    text: nextSectionVisible ? t('group.createGroup.btnNext') : t('group.createGroup.btnNext'),
                    size: 'large',
                    clickHandler: nextSectionVisible ? jumpToNextAfterUpdate : handleNext,
                    disabled:
                      !nextSectionVisible &&
                      (selectedInterests?.length < appConstantSettings.MIN_INTEREST_COUNT ||
                        selectedInterests?.length > appConstantSettings.MAX_INTEREST_COUNT)
                  }
                : null
            }
            secondaryButton={
              editMode && interestsUpdated && { text: t('global.cancel'), size: 'large', clickHandler: handleCancel }
            }
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default GroupInterests
